<template>
  <interview-layout>
    <div class="container w-100 d-flex flex-column">
      <div class="submit-result-indicator">
        <div class="submit-message">
          <div class="text-success pulse-opacity-infinite" v-show="busy">
            <i class="bi bi-arrow-down-up me-2"></i>
            Resultaat opslaan...
          </div>
          <div class="text-success" v-show="resultSubmitted">
            <i class="bi bi-check-lg me-2"></i>
            Opgeslagen!
          </div>
          <div class="text-danger" v-show="!busy && !resultSubmitted">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            Er is iets fout gegaan!
          </div>
        </div>
      </div>

      <h1 class="px-4 fade-in-up-enter-active animation-slowest max-100">
        <span class="text-primary">{{ mainTitle }}</span>
      </h1>
      <h5 class="px-4 fade-in-up-enter-active animation-slowest delay-200 max-100" v-html="subTitle"></h5>
    </div>
  </interview-layout>
</template>

<script>
import InterviewLayout from "@/views/layouts/InterviewLayout.vue";
import { useAllStores } from "@/helpers/UseAllStores";
import { LeadDataService } from "@/services/LeadDataService";

export default {
  components: { InterviewLayout },
  setup() {
    return { ...useAllStores() };
  },
  data() {
    return {
      busy: false,
      resultSubmitted: false
    };
  },
  computed: {
    mainTitle() {
      return 'Dit was het gesprek';
    },
    subTitle() {
      return 'We nemen weer contact met u op op het moment dat het isolatieplan beschikbaar is.';
    }
  },
  methods: {
    submitResult() {
      this.busy = true;
      LeadDataService.pushRemoteData(this.uiStore.uuid, true)
        .then(() => {
          this.resultSubmitted = true;
        })
        .catch(() => {
          this.resultSubmitted = false;
        })
        .finally(() => {
          this.busy = false;
        });
    }
  },
  mounted() {
    this.lead.meta.StatusIsolatieplan = 'Wacht op isolatieplan';
    this.lead.meta.HadAdviesGesprek = true;
    this.submitResult();
  }
};
</script>

<style scoped>
.submit-result-indicator {
  padding: 0 1rem;
  margin-bottom: 0.5rem;
  opacity: 0.8;
}
.submit-message {
  font-weight: 600;
  font-size: 0.9em;
  text-transform: uppercase;
}
.pulse-opacity-infinite {
  animation: pulseOpacity 1.6s infinite ease-in-out;
}
@keyframes pulseOpacity {
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
}
</style>